import API from "@/api";

import { getField, updateField } from "vuex-map-fields";

const initialState = () => ({
  estados: [],
  municipios: [],
  regioesSaude: [],
});

export const state = initialState();

export const getters = {
  getField,
  filterMunicipios: () => (municipio) => filterMunicipios(municipio),
  formatMunicipio: () => (nmRegiaoSaude) => formatMunicipio(nmRegiaoSaude),
};

function filterMunicipios({ nmRegiaoSaude, municipioItems }) {
  if (nmRegiaoSaude) {
    return municipioItems.filter(
      (item) => item.nmRegiaoSaude === nmRegiaoSaude
    );
  } else {
    return municipioItems;
  }
}

function formatMunicipio(municipio) {
  return {
    idMunicipio: municipio.id,
    nmMunicipio: municipio.nome,
    nmRegiaoSaude: municipio.regiao_saude,
  };
}

export const actions = {
  async getEstados({ commit }) {
    API.axios.get("/extreme-localidade/api/v1/estados").then((res) => {
      if (res.status === 200) {
        commit("updateField", { path: "estados", value: res.data });
      } else {
        commit("updateField", { path: "estados", value: null });
      }
    });
  },

  async getMunicipios({ commit }, uf) {
    if (uf === null) {
      uf = "RJ";
    }

    API.axios
      .get(`/extreme-localidade/api/v1/municipios?uf=${uf}`)
      .then((res) => {
        if (res?.status === 200) {
          commit("updateField", { path: "municipios", value: res.data });
        } else {
          commit("updateField", { path: "municipios", value: null });
        }
      });
  },
  async getRegioesSaude({ commit }, uf) {
    if (uf === null) {
      uf = "RJ";
    }

    API.axios
      .get(`/extreme-localidade/api/v1/estados/${uf}/regioes-saude`)
      .then((res) => {
        if (res.status === 200) {
          commit("updateField", { path: "regioesSaude", value: res.data });
        } else {
          commit("updateField", { path: "regioesSaude", value: null });
        }
      });
  },

  resetState({ commit }) {
    commit("resetState");
  },
};

export const mutations = {
  updateField,
  resetState(state) {
    Object.assign(state, initialState());
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
